import { isFileRejection } from './types.js';

const createNoFileError = ()=>new Error('no-file')
;
const LABEL_PREFIX = 'upload.error';
const labelMapping = {
    'file-invalid-type': `${LABEL_PREFIX}.fileInvalidType`,
    'file-too-large': `${LABEL_PREFIX}.fileTooLarge`,
    'file-too-small': `${LABEL_PREFIX}.fileTooSmall`,
    'too-many-files': `${LABEL_PREFIX}.tooManyFiles`,
    'no-file': `${LABEL_PREFIX}.noFile`,
    unknown: `${LABEL_PREFIX}.unknown`
};
var ref;
const getUploadErrorLabel = (currentError)=>{
    var ref1;
    return (isFileRejection(currentError) ? labelMapping[(ref = (ref1 = currentError.errors[0]) === null || ref1 === void 0 ? void 0 : ref1.code) !== null && ref !== void 0 ? ref : ''] : labelMapping[currentError.message]) || labelMapping.unknown;
};

export { createNoFileError, getUploadErrorLabel };
//# sourceMappingURL=utils.js.map
